<script setup lang="ts">
const route = useRoute();
const fullPath = route.fullPath;

const { data, error, pending } = await useAsyncData('home', async (nuxtApp) => {
  try {
    const url = `/api/home/`;
    const response = await $fetch<any>(url);
    return response;
  } catch (fetchError: any) {
    console.error('[INDEX] Fetch error:', fetchError);
    throw fetchError;
  }
});
const home = computed(() => data.value?.home?.page?.cptPages?.home);
const featuredProgramsProps = computed(() => ({
  heading: home.value?.bodyFeaturedPrograms?.heading,
  areasOfStudyFeaturedPrograms: home.value?.bodyFeaturedPrograms?.areasOfStudyFeaturedPrograms,
  popularFeaturedPrograms: home.value?.bodyFeaturedPrograms?.popularFeaturedPrograms,
}));
const ctaFormFiledsProps = computed(() => ({
  heading: 'ready to<br /><span class="text-accent-500">learn more?</span>',
  paragraphs: '<p>Fill out the form, and an Admissions Counselors will be happy to answer all your questions.</p>',
}));
</script>

<template>
  <div
    class="scroll-mt-15"
    style="
      background:
        url('/images/bg-right-pattern.svg') right no-repeat,
        linear-gradient(184deg, #fbf5e7 1.28%, #fff 94.01%);
      background-size: auto, auto;
      overflow: hidden;
      background-position: top right;
    "
  >
    <ArticlesHubArticleSearch />
    <!-- Additional Sections -->
    <CTAFormFields v-bind="ctaFormFiledsProps" />
    <div
      class="scroll-mt-15.5"
      style="
        background:
          url('/images/bg-right-pattern.svg') right no-repeat,
          linear-gradient(184deg, #fbf5e7 1.28%, #fff 94.01%);
        background-size: auto, auto;
        overflow: hidden;
        background-position: top right;
      "
    >
      <FeaturedPrograms v-bind="featuredProgramsProps" />
    </div>
  </div>
</template>
